module.exports = __webpack_public_path__ + "img/RayssaCoelho-IMG.e21a771a.jpg";